import { Box } from "@mui/material";
import styled from "@mui/styled-engine";
import markOne from "../assets/images/marks/mark-1.svg";
import markTwo from "../assets/images/marks/mark-2.svg";
import markThree from "../assets/images/marks/mark-3.svg";

interface CricketMarkProps {
  markAmount: number;
  height: number;
}

export default function CricketMark({ markAmount, height }: CricketMarkProps) {
  return (
    <Box
      height={height}
      display="flex"
      alignItems="center"
      justifyContent="center"
      position="relative"
    >
      <MarkImg
        height={height}
        alt={`1 cricket mark`}
        src={markOne}
        show={markAmount === 1}
      />
      <MarkImg
        height={height}
        alt={`2 cricket marks`}
        show={markAmount === 2}
        src={markTwo}
      />
      <MarkImg
        height={height}
        alt={`3 cricket marks`}
        show={markAmount === 3}
        src={markThree}
      />
    </Box>
  );
}

const MarkImg = styled("img")<{ show: boolean; height: number }>(
  ({ show, height }) => ({
    height: height,
    position: "absolute",
    visibility: !show ? "hidden" : "visible",
  })
);
